///////// Lib. /////////
////////////////////////

// ...

/////// Utils.. ////////
////////////////////////

function show_notif_error(display) {
  const msg = "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.";
  const span = display.querySelector("span");
  display.dataset.hidden = "false";
  if (span) span.innerHTML = `<div class="notif error text-cef-red">${msg}</div>`;
}
function show_notif_error_emails(display) {
  const msg = "Bitte geben Sie eine gültige E-Mail-Adresse ein.";
  const span = display.querySelector("span");
  display.dataset.hidden = "false";
  if (span) span.innerHTML = `<div class="notif error text-cef-red">${msg}</div>`;
}

function show_notif_success(display) {
  const msg = "Vielen Danke, ihre E-Mail-Adresse wurde gespeichert.";
  const span = display.querySelector("span");
  display.dataset.hidden = "false";
  if (span) span.innerHTML = `<div class="notif success text-green-500">${msg}</div>`;
}

function hide_notif(display) {
  display.dataset.hidden = "true";
  const span = display.querySelector("span");
  if (span) span.innerHTML = "";
}

///// Event hdls. //////
////////////////////////

// ...

//////// Assets ////////
////////////////////////

const logArgs = { eventName: "api.submit", inline: true, disabled: false };
const msgs = {
  start: ["EmailSubmissionForm", "API", "submit"],
  end: ["EmailSubmissionForm", "API", "submit", "API call complete"],
};

////// API method def. ///////
//////////////////////////////

export default function submit() {
  //////// Setup /////////
  ////////////////////////

  const submitRoute = "data-collection/submit/email";
  const { field_firstName, field_lastName, field_email, field_msg, display_notifs } = this.ref;
  this.logger("event", msgs.start, "event", logArgs);

  /// Email submission ///
  ////////////////////////

  // Validate email field //
  const emailValue = field_email?.value || "";
  const emailIsValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(emailValue);
  if (!emailIsValid) {
    show_notif_error_emails(display_notifs);
    setTimeout(() => hide_notif(display_notifs), 3000);
    this.logger("error", ["EmailSubmissionForm", "API", "submit", "invalid email"], "error", logArgs);
    return;
  }

  // Req. config. //
  const req = new XMLHttpRequest();
  const formData = new FormData();

  // Data //
  formData.append("firstName", field_firstName?.value);
  formData.append("lastName", field_lastName?.value);
  formData.append("email", field_email?.value);
  formData.append("msg", field_msg?.value);

  // Request init. //
  req.open("POST", submitRoute, true);

  // Response hdl. //
  req.onreadystatechange = () => {
    if (req.readyState === 4) {
      // Setup //
      // const resp = req.response;
      // console.log("%cEmailSubmissionForm API submit response:", consoleStyles.default, resp);
      const is_success = req.status === 200;
      const is_error = req.status >= 400;

      // Notification //
      if (is_success) {
        show_notif_success(display_notifs);
        // Reset form
        field_firstName.value = "";
        field_lastName.value = "";
        field_email.value = "";
        field_msg.value = "";
      } else if (is_error) {
        show_notif_error(display_notifs);
      }

      // Clear notification after 3 seconds
      if (is_success || is_error) setTimeout(() => hide_notif(display_notifs), 3000);
    }
  };

  // Request send. //
  req.send(formData);

  /////// Conclude ///////
  ////////////////////////

  this.logger("success", msgs.end, "success", logArgs);
}
